import React, { useState, useEffect } from 'react';
import cN from 'classnames';
import * as Tag from '@components/Common/Tag';
import * as Icons from '@components/Common/Icons';
import { I_SingleGroup, I_TripType } from '@Redux/search/interfaces';
import ResultListFlight from '@components/SearchPage/ResultListFlight';
import Tags from '@components/Common/Tags';
import { getIsCompared, handleCompare } from '@utils/compare';
import styles from '../styles.module.scss';
import domainByEnv from '@utils/domainByEnv';
import { homeDomain } from '@utils/domainForCompany';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

interface I_Props {
    groupData: I_SingleGroup;
    setIsContactStaffOpen: Function;
}

const SingleList: React.FC<I_Props> = ({ groupData, setIsContactStaffOpen }) => {
    const {
        IsVip,
        IsCruise,
        TourBu,
        TourName,
        TripTypeList,
        TagList,
        TourDays,
        GroupID,
        IsEnsureGroup,
        TotalSeats,
        QuotaSeats,
        VipOrigPrice,
        StraightLowestPrice,
        StatusText,
        Status,
        HasFlight,
        GoDate,
        StatusUrl,
        NormGroupID,
        TravelType,
        StartFromCityList,
        DirectionList,
    } = groupData;
    const [isLightBoxOpen, setIsLightBoxOpen] = useState<boolean>(false);
    const [isCompared, setIsCompared] = useState<boolean>(false);
    const { t } = useTranslation();
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    // 比較
    useEffect(() => {
        (async () => {
            await getIsCompared({
                TourDays,
                GoDate,
                NormGroupID,
                NormGroup: TourName,
                GroupID,
                TravelType,
                setIsCompared,
            });
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const reformTripTypeList = TripTypeList.map((trip: I_TripType) => ({
        Name: trip.TypeName,
        Code: trip.TypeCode,
    }));

    // const productUrl = (GroupID: string) => `${domainByEnv(false)}/detail?GroupID=${GroupID}`;

    const productUrl = (GroupID: string) =>
        process.env.ENV === 'local'
            ? `${homeDomain}/travel/detail?GroupID=${GroupID}`
            : `${domainByEnv(false)}/detail?GroupID=${GroupID}`;

    const whereToGoRender = () => {
        const result =
            StartFromCityList &&
            StartFromCityList.length > 0 &&
            StartFromCityList.reduce(
                (pre, cur) =>
                    pre.CityName
                        ? { CityName: `${pre.CityName}、${cur.CityName}` }
                        : { CityName: cur.CityName },
                { CityName: '' }
            );
        return (
            <div>
                <span>出發地點：</span>
                {result ? <span>{result.CityName}</span> : <span>－－</span>}
            </div>
        );
    };

    return (
        <a
            className={styles.singleCard}
            href={productUrl(GroupID)}
            target="_blank"
            rel="noreferrer noopener"
        >
            <div className={styles.controlTag}>
                <div className={styles.buttons}>
                    <span
                        onClick={(e) => {
                            e.preventDefault();
                            handleCompare({
                                TravelType,
                                Price: IsVip ? VipOrigPrice : StraightLowestPrice,
                                TourDays,
                                NormGroup: TourName,
                                GoDate: GoDate.split('(')[0], // 原資料 "2021/05/19(三)" 取日期部分
                                GroupID: GroupID,
                                NormGroupID,
                                isCompared,
                                setIsCompared,
                            });
                        }}
                    >
                        <Icons.Compare fill={isCompared ? '#f03742' : '#999'} />
                        <span style={{ color: isCompared ? '#f03742' : '#999' }}>比較</span>
                    </span>
                </div>
            </div>
            <div className={styles.singleHeader}>
                <div className={styles.kindTag}>
                    {/* <Tag.Featured text="雄獅推薦" /> */}
                    {IsVip && <Tag.Featured text="會員限購" />}
                    {IsCruise && <Tag.Featured text="郵輪優先選房號" />}
                </div>
                {TourBu && <div className={styles.title}>聯營商品:{TourBu}</div>}
            </div>

            <div
                className={styles.singleBody}
                /* 如果字的內容不構會看起來像破圖*/
                style={TourName.length < 28 && !isMobile ? { paddingTop: '10px' } : {}}
            >
                <div className={styles.tirpInfo}>
                    <span className={styles.caption}>{TourName}</span>
                    <Tags TripTypeList={reformTripTypeList} TagList={TagList} />
                </div>
                <div className={styles.date}>
                    <div data-title-m="日期：">
                        {GoDate}
                        <span>{TourDays}天</span>
                    </div>

                    {
                        /*團號 成形icon 只會在m版出現*/
                        isMobile && (
                            <div data-title-m="" className={styles.num}>
                                {GroupID}
                                {IsEnsureGroup && (
                                    <span className={cN(styles.isDone)}>{t('IsEnsureGroup')}</span>
                                )}
                            </div>
                        )
                    }

                    {/*出發地 只會在m版出現*/ isMobile && whereToGoRender()}
                </div>
                <div className={styles.flightInfo}>
                    <div data-title-m="航空：" data-title-pc="">
                        {HasFlight ? (
                            <div
                                className={styles.flightInfoData}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setIsLightBoxOpen(true);
                                }}
                            >
                                航班資訊
                            </div>
                        ) : (
                            <span>一一</span>
                        )}
                    </div>
                </div>
                <div className={styles.sell}>
                    <div data-title-m={`機位：${t('seats')}`} data-title-pc={`${t('seats')} `}>
                        {TotalSeats}
                    </div>
                    <div data-title-m="可賣：" data-title-pc="可賣 ">
                        {QuotaSeats}
                    </div>
                </div>
                <div className={styles.priceWrap}>
                    <div className={styles.price}>
                        {IsVip && (
                            <div className={styles.origPrice}>
                                原價：<span data-unit="人/起">{VipOrigPrice}</span>
                            </div>
                        )}

                        <div
                            data-currency="TWD"
                            data-unit="人/起"
                            className={cN(styles.sellPrice, {
                                [`${styles.upcoming}`]: Status === 6,
                            })}
                        >
                            {Status === 6 ? '近期上架' : StraightLowestPrice}
                        </div>
                    </div>
                    <span
                        // href={StatusUrl}
                        onClick={(e) => {
                            e.preventDefault();
                            Status === 4 ? setIsContactStaffOpen(true) : window.open(StatusUrl);
                        }}
                        className={cN(styles.orderBtn, {
                            [`${styles.close}`]: Status == 3 || Status == 5,
                        })}
                    >
                        {StatusText}
                    </span>
                </div>
            </div>

            {!isMobile /* bbc 資料呈現位置 有出發地 團號*/ ? (
                <div className={styles.singleInfo_ForPC}>
                    {whereToGoRender()}
                    <div>
                        <span>
                            {GroupID}
                            {IsEnsureGroup && (
                                <span className={styles.isDone}>{t('IsEnsureGroup')}</span>
                            )}
                        </span>
                    </div>
                </div>
            ) : null}

            {/* 航班資訊光箱 */}
            {HasFlight && (
                <ResultListFlight
                    groupData={{
                        NormGroupID,
                        GroupID,
                        GoDate: GoDate.split('(')[0].replace(/\//g, '-'),
                        DirectionList,
                    }}
                    open={isLightBoxOpen}
                    ToggleLightBox={setIsLightBoxOpen}
                />
            )}
        </a>
    );
};

export default SingleList;
